// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
module.exports = ['computer', 'trello', 'link', 'google-drive', 'dropbox', 'box', 'onedrive'];